import moment from 'moment';
import Collection from 'core/model/Collection';
import ProviderModel from './ProviderModel';

class ProviderCollection extends Collection {
  get url() {
    return '/api/ui/ott/provider';
  }

  get model() {
    return ProviderModel;
  }

  get defaultSortState() {
    return {
      field: 'name',
      direction: 'asc'
    };
  }

  get filterFieldWhitelist() {
    return new Set(['id', 'name']);
  }

  get lastUpdate() {
    return this.get().reduce((d, i) => Math.max(d, moment(i.get('edate')).valueOf()), 0);
  }
}

export default ProviderCollection;
